module.exports = __webpack_public_path__ + "img/sui5.2fe0481d.png";